/**
 * Brightness Style02 - 滑桿樣式：僅數值
 * 高度三倍、無球點、桿中指示、百分比置中
 */
import { useState, useEffect } from 'react'
import type { TraitControlProps } from './types'
import './BrightnessStyle02.css'

export function BrightnessStyle02({
  state,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const currentBrightness = (state?.brightness as number) ?? 100
  const [brightness, setBrightness] = useState(currentBrightness)
  useEffect(() => {
    setBrightness((state?.brightness as number) ?? 100)
  }, [state?.brightness])

  const handleChange = (value: number) => {
    setBrightness(value)
    void onCommand('setBrightness', { brightness: value })
  }

  return (
    <div className="trait-brightness-style02">
      <div
        className="trait-brightness-style02__track-wrap"
        style={{
          background: `linear-gradient(to right, #facc15 0%, #facc15 ${brightness}%, rgba(255,255,255,0.12) ${brightness}%, rgba(255,255,255,0.12) 100%)`,
        }}
      >
        <input
          type="range"
          min={0}
          max={100}
          value={brightness}
          onChange={(e) => setBrightness(Number(e.target.value))}
          onMouseUp={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
          onTouchEnd={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
          className="trait-brightness-style02__range"
          disabled={disabled}
        />
      </div>
      <span className="trait-brightness-style02__value">{brightness}%</span>
    </div>
  )
}
